import { useEffect } from 'react';
import { fullUrl, type CyberpunkPhoto } from '../../api/types';
import styles from './CyberpunkLightbox.module.css';

interface LightboxProps {
  photo: CyberpunkPhoto;
  onClose: () => void;
}

/** 日记日期：diary_date 优先，回退入库日期 */
function diaryDateOf(photo: CyberpunkPhoto): string {
  return photo.diary_date || photo.created_at.slice(0, 10);
}

export default function CyberpunkLightbox({ photo, onClose }: LightboxProps) {
  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [onClose]);

  const hasDiary = Boolean(photo.title || photo.description);

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div
        className={`${styles.container} ${hasDiary ? styles.containerDiary : ''}`}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close corner */}
        <button className={styles.closeBtn} onClick={onClose}>
          [×] CLOSE
        </button>

        {/* Scanline */}
        <div className={styles.scanline} />

        <div className={hasDiary ? styles.diaryLayout : styles.soloLayout}>
          {/* Image with glitch */}
          <div className={styles.imageWrapper}>
            <img
              src={fullUrl(photo)}
              alt={photo.title || photo.filename}
              className={styles.image}
            />
            <div className={styles.glitchLayer} />
            <div className={styles.crtOverlay} />
          </div>

          {/* Diary panel（画面文案） */}
          {hasDiary && (
            <aside className={styles.diaryPanel}>
              <div className={styles.diaryDate}>// LOG {diaryDateOf(photo)}</div>
              {photo.title && (
                <h2 className={styles.diaryTitle} data-text={photo.title}>
                  {photo.title}
                </h2>
              )}
              {photo.description && (
                <p className={styles.diaryText}>{photo.description}</p>
              )}
              <div className={styles.diaryMeta}>
                <span>REC: {photo.uploaded_by || 'UNKNOWN'}</span>
                <span className={styles.pulse}>● LOGGED</span>
              </div>
            </aside>
          )}
        </div>

        {/* Data footer */}
        <div className={styles.footer}>
          <span className={styles.filename}>{(photo.title || photo.filename).toUpperCase()}</span>
          <span className={styles.pulse}>● ONLINE</span>
        </div>
      </div>
    </div>
  );
}
